import { ComponentType, lazy } from "react";

import { delay } from "./PromiseUtils";
import { isChunkLoadError } from "./utils";

async function retry<C extends ComponentType<any>>(
  asyncFn: () => Promise<{ default: C }>,
  nRetries: number,
  minDelayBetweeenRetries: number,
): Promise<{ default: C }> {
  try {
    return await asyncFn();
  } catch (err) {
    if (isChunkLoadError(err)) {
      if (nRetries > 0) {
        console.log("Retrying lazy load due to chunk error:", err);
        await delay(
          minDelayBetweeenRetries + Math.random() * minDelayBetweeenRetries,
        );
        return await retry<C>(asyncFn, nRetries - 1, minDelayBetweeenRetries);
      }
    }
    throw err;
  }
}

export default function lazyWithRetry<C extends ComponentType<any>>(
  importFn: () => Promise<{ default: C }>,
  nRetries = 5,
  minDelayBetweeenRetries = 300,
) {
  return lazy<C>(() => retry(importFn, nRetries, minDelayBetweeenRetries));
}
